import React from 'react';
import { JsonForms } from '@jsonforms/react';
import {
  materialRenderers,
  materialCells,
} from '@jsonforms/material-renderers';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { InputLabel, TextField, Box } from '@mui/material';

// Кастомный рендерер для Table head
const CustomTableLabelRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, errors, visible } = props;

  // Обработчик изменения значения
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    // Добавляем префикс "Hello, " к значению
    handleChange(path, newValue ? `Hello, ${newValue}` : '');
  };

  // Если элемент невидим, не рендерим ничего
  if (!visible) {
    return null;
  }

  //console.log(data)
  //console.log(schema)
  //console.log(uischema.text)


  let sx = {color: 'rgb(0,83,146)', 
        marginTop: 2, 
        marginBottom: 10, 
        border: 1, 
        borderRadius: 1, 
        height: "85%", 
        padding: "12px", 
        display: "flex", 
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600
  }

  if (uischema.options.minWidth !== undefined) {
    //let minWidth = uischema.options.minWidth
    sx['minWidth'] = uischema.options.minWidth
  }

  
  return (
    <Box sx={sx}>
        {/*<InputLabel>{uischema.label || schema.title || 'Custom Input'}</InputLabel>*/}
        <p>{uischema.text}</p>
    </Box>
  );
};

// Оборачиваем рендерер с помощью withJsonFormsControlProps
export const CustomTableLabelControl = withJsonFormsControlProps(CustomTableLabelRenderer);




// Кастомный рендерер для Fixedcell
const CustomFixedcellLabelRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, errors, visible } = props;

  // Обработчик изменения значения
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    // Добавляем префикс "Hello, " к значению
    handleChange(path, newValue ? `Hello, ${newValue}` : '');
  };

  // Если элемент невидим, не рендерим ничего
  if (!visible) {
    return null;
  }

  //console.log(data)

  let sx={ 
        color: 'rgb(0,83,146)', 
        marginTop: 0, 
        marginBottom: 1, 
        border: 1, 
        borderRadius: 1, 
        //height: "85%", 
        paddingTop: "14px", 
        paddingBottom: "14px", 
        display: "flex", 
        alignItems: "center",
        justifyContent: "center",
        fontSize: 14, 
        fontWeight: 600,
        minWidth: 160,
      }

  if (uischema.options.minWidth !== undefined) {
    sx['minWidth'] = uischema.options.minWidth
  }

  return (
    <Box sx={sx}>
      <p style={{margin: "2px"}}>{uischema.text}</p>
    </Box>
  );
};

// Оборачиваем рендерер с помощью withJsonFormsControlProps
export const CustomFixedcellLabelControl = withJsonFormsControlProps(CustomFixedcellLabelRenderer);






const SmallLabelRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, errors, visible } = props;

  // Обработчик изменения значения
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    // Добавляем префикс "Hello, " к значению
    handleChange(path, newValue ? `Hello, ${newValue}` : '');
  };

  if (!visible) {
    return null;
  }

  return (
    <Box sx={{ 
        color: 'rgb(0,83,146)', 
        marginTop: 1, 
        marginBottom: 0, 
      }}>
      {/*<InputLabel>{uischema.label || schema.title || 'Custom Input'}</InputLabel>*/}
      <h6>{uischema.text}</h6>
    </Box>
  );
};

export const SmallLabelControl = withJsonFormsControlProps(SmallLabelRenderer);

